import * as styles from "./PopoverDescription.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverDescriptionProps } from "./Popover.types";

export function PopoverDescription({
  className,
  ...props
}: PopoverDescriptionProps): JSX.Element {
  return (
    <BasePopover.Description
      data-slot="popover-description"
      className={clsx(styles.description, className)}
      {...props}
    />
  );
}
